export default __webpack_public_path__ + "static/media/location--9.0dfba5a1.jpg";